import { Trello } from "./types/trello"

const PUP_DISPLAY_NAME = "Quickbooks"
const PUP_ID = "8"
const QUERY_LIMIT = 100

/**
 * Version stamp for the persisted React Query cache (see app.tsx).
 *
 * The cache lives in localStorage for 30 minutes, which means a browser can
 * carry a query's *old* result shape across a deploy and hand it to code that
 * expects the new one. Bump this whenever a persisted query's data shape
 * changes and every stored cache is thrown away instead.
 *
 * History, as a reminder that this is easy to forget and expensive to miss:
 *   2 — reportBoardCards became { cardsById, memberNames }
 *   3 — memberNames values went from { name, initials } to a plain name
 *   4 — cards in an archived list are now flagged archived; cached rows
 *       from before this carry the wrong answer, not just an old shape
 *   5 — reportBoardCards gained boardName
 *   6 — board member names are full names now, not initials
 *   7 — the card back's member lookup returns a badge, not a name string
 *   8 — the report's member lookup returns badges too, and the key changed
 */
const QUERY_CACHE_VERSION = "8"

const CAPABILITY_PROPS = {
  baseUrl: import.meta.env.VITE_BASE_URL ?? "",
  // `dark` is the icon for a dark board, i.e. the white one. Trello recolors
  // some slots by alpha and leaves others alone, so both files exist and the
  // capabilities pick per slot.
  logo: {
    dark: "/static/qb-glyph-dark.svg",
    light: "/static/qb-glyph.svg"
  },
  icon: {
    dark: "/static/qb-glyph-dark.svg",
    light: "/static/qb-glyph.svg"
  },
  authorizeIcon: {
    dark: "/static/authorize-icon.svg",
    light: "/static/authorize-icon.svg"
  }
}

const HELP_ACTION = {
  icon: "https://trello.bluedashersoftware.com/static/help.svg",
  alt: "help",
  position: "right" as "right" | "left",
  callback: (t: Trello.PowerUp.IFrame) => {
    return t.popup({
      title: "Help Center",
      url: "./help.html",
      height: 300
    })
  }
}

export {
  PUP_DISPLAY_NAME,
  PUP_ID,
  CAPABILITY_PROPS,
  HELP_ACTION,
  QUERY_LIMIT,
  QUERY_CACHE_VERSION
}
